<template>
  <div
    class="monitor"
    style="font-size: 16px; width: 100%; background: #eff1f5"
  >
    <div class="content">
      <div class="yuliang" ref="yuliang" style="margin-top: 0">
        <div class="select clearfix" ref="districtrainOperation">
          <!-- <span class="desc">时间:</span>
          <div style="display: inline-block">
            <el-date-picker
              v-model="query.begTime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择开始时间"
              default-time="08:00:00"
              :clearable="false"
              :editable="false"
            ></el-date-picker>
          </div> -->
          <!-- <span id="select" @click="searchData">查询</span>
          <span id="export" @click="exportExcel"> -->
          <!-- <span id="select">查询</span> -->
          <div id="export" @click="exportDocx">
            <div class="export-icon" ref="downloadArea"></div>导出
          </div>
        </div>
        <div class="tableDiv" ref="tableDiv">
          <div class='tinymce' style="width:100%;height:100%" v-loading = "loading">
          <editor id='tinymce' v-model='tinymceHtml' :init="init"></editor>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import htmlDocx from 'html-docx-js/dist/html-docx' // html转word
import saveAs from 'file-saver'
import tinymce from 'tinymce/tinymce.min.js'
// import 'tinymce/themes/silver/theme'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver'
import 'tinymce/plugins/image'
import 'tinymce/plugins/link'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/contextmenu'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/print'
import 'tinymce/icons/default/icons'
import reportAnalysisTypes from '@/store/types/reportAnalysis'
export default {
  name: 'tinymce',
  data () {
    return {
      loading: true,
      query: {
        addvcd: '330324',
        begTime: ''
      },
      tinymceHeight: 700,
      tdata: [],
      sortTheData: [],
      tinymceHtml: '',
      showTrData: '',
      tableFrame: '',
      init: {
        selector: '.tinymce',
        language_url: 'tinymce/zh_CN.js',
        language: 'zh_CN',
        skin_url: 'tinymce/skins/ui/oxide', // 皮肤引入错误可能不显示
        content_css: 'tinymce/station_arrive_rate.css', // 内联模式引入css
        auto_focus: false,
        height: '100%',
        plugins: 'print link lists image code table colorpicker textcolor wordcount contextmenu',
        toolbar:
          'print bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image code | removeformat',
        branding: false,
        inline: false
        // menubar: false
      }
    }
  },
  components: {
    Editor
  },
  methods: {
    getShowDataTr () { // 富文本内页面拼接
      this.tinymceHtml = ` <div class="table-content" >
            <table cellspacing:0  style="width: 100%; margin-top: -5px; border-collapse: collapse;">
            <thead ref="thead">
              <tr class="firstRow" style="background: #b0c0d5;">
                <th style="text-align: center; vertical-align: center; font-size: 14pt; border: 1px solid #ccc; padding: 5px 0 5px 0;">乡镇</th>
                <th style="text-align: center; vertical-align: center; font-size: 14pt; border: 1px solid #ccc; padding: 5px 0 5px 0;">设备码</th>
                <th style="text-align: center; vertical-align: center; font-size: 14pt; border: 1px solid #ccc; padding: 5px 0 5px 0;">站名</th>
                <th style="text-align: center; vertical-align: center; font-size: 14pt; border: 1px solid #ccc; padding: 5px 0 5px 0;">是否显示</th>
                <th style="text-align: center; vertical-align: center; font-size: 14pt; border: 1px solid #ccc; padding: 5px 0 5px 0;">状态</th>
                <th style="text-align: center; vertical-align: center; font-size: 14pt; border: 1px solid #ccc; padding: 5px 0 5px 0;">最后一次到站时间</th>
              </tr>
            </thead>
            <tbody ref="tbody" >
             ${this.tableFrame}
            </tbody>
          </table>
          </div> `
    },
    // sortData () {
    //   let tempArr = []
    //   // let Data = []
    //   for (let i = 0; i < this.tdata.length; i++) {
    //     if (tempArr.indexOf(this.tdata[i].town) === -1) {
    //       this.sortTheData.push({
    //         town: this.tdata[i].town,
    //         dataInfo: [this.tdata[i]]
    //       })
    //       tempArr.push(this.tdata[i].town)
    //     } else {
    //       for (let j = 0; j < this.sortTheData.length; j++) {
    //         if (this.sortTheData[j].town === this.tdata[i].town) {
    //           this.sortTheData[j].dataInfo.push(this.tdata[i])
    //           break
    //         }
    //       }
    //     }
    //   }
    // },
    tabledata () {
      this.tableFrame = ''
      this.loading = true
      this.$store
        .dispatch(reportAnalysisTypes.STATION_ARRIVE_RATE)
        .then(data => {
          this.tdata = data.rows
          // this.tdata.forEach(el => {
          //   this.tableFrame += `<tr>
          //     <td >${el.town}</td>
          //       <td>${el.stnm}</td>
          //       <td>${el.state === 1 ? '√' : 'x'}</td>
          //       <td>${el.time}</td>
          //     </tr>`
          // })
          for (let i = 0; i < this.tdata.length; i++) {
            this.tableFrame += `<tr>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;" rowspan="${this.tdata[i].townList.length}">${this.tdata[i].townList[0].town}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.tdata[i].townList[0].stcd ? this.tdata[i].townList[0].stcd : '-'}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.tdata[i].townList[0].stnm}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.tdata[i].townList[0].mainStation === true ? '是' : '否'}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.tdata[i].townList[0].state === 1 ? '√' : 'x'}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.tdata[i].townList[0].time}</td>
            </tr>`
            for (let j = 1; j < this.tdata[i].townList.length; j++) {
              this.tableFrame += `<tr>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.tdata[i].townList[j].stcd ? this.tdata[i].townList[j].stcd : '-'}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.tdata[i].townList[j].stnm}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.tdata[i].townList[j].mainStation === true ? '是' : '否'}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.tdata[i].townList[j].state === 1 ? '√' : 'x'}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.tdata[i].townList[j].time}</td>
                </tr>`
            }
          }
          this.loading = false
          this.getShowDataTr()
        })
    },
    // 转换图片为 base64 (todo: 有可能因跨域报错)
    convertImagesToBase64 (contentDocument) {
      // 找到所有的图片
      let imgs = contentDocument.querySelectorAll('img')
      // 图片转换用
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      imgs.forEach((img, i) => {
        if (img.src.startsWith('data:image')) return
        // img表现尺寸
        let realWidth = parseInt(img.style.width)
        let realHeight = parseInt(img.style.height)

        // 清空画布并调整为 img 的大小
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        canvas.width = realWidth
        canvas.height = realHeight
        // 画图片到画布
        ctx.drawImage(
          img,
          0,
          0,
          img.width,
          img.height,
          0,
          0,
          realWidth,
          realHeight
        )
        // ctx.drawImage(img, 0, 0);

        // 画布转为 base64
        let dataURL = canvas.toDataURL()
        img.setAttribute('src', dataURL)
      })

      canvas.remove()
    },
    convertChartsToBase64 (contentDocument) {
      // 找到所有的图表 （echart）
      let canvases = contentDocument.querySelectorAll('canvas')
      // 遍历图表，转换为 base64 静态图片
      canvases.forEach((canvas, i) => {
        let echart = this.$refs.chart[i]
        let url = echart.getDataURL()
        let img = document.createElement('img')
        img.src = url
        canvas.parentNode.replaceChild(img, canvas)
      })
    },
    // 生成下载链接
    createDownloadLink (fileObj, fileName) {
      let link = document.createElement('a')
      link.href = URL.createObjectURL(fileObj)
      link.download = fileName || 'document.docx'
      link.appendChild(document.createTextNode(''))
      return link
    },
    exportDocx () {
      // 获取页面dom元素
      let contentDocument = this.tinymceHtml
      let content = `<!DOCTYPE html>
            <head>
                <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
                <style>
                .table-content {
                    height: 1510px;
                  }
                  .table-content table {
                    width: 100%;
                    height: 100%;
                    font-size: 15px;
                    border-collapse:collapse;
                    border-spacing:0px 0px;
                  }
                  .table-content table thead {
                    display: table;
                    width: 100%;
                    height: 50px;
                    table-layout: fixed;
                  }
                  .table-content table tr th {
                    text-align: center;
                    vertical-align: middle;
                    border: 1px solid #ebeff6;
                  }
                  .table-content table tr th:nth-child(1) {
                    width: 10%;
                  }
                  .table-content table tr th:nth-child(2) {
                    width: 30%;
                  }
                  .table-content table tr th:nth-child(3) {
                    width: 10%;
                  }
                  .table-content table tr th:nth-child(4) {
                    width: 30%;
                  }
                  .table-content table tbody {
                    display: block;
                    height: 100px;
                  }
                  .table-content table tbody  tr {
                    display: table;
                    width: 100%;
                    table-layout: fixed;
                    text-align: center;
                    vertical-align: middle;
                    border: 1px solid #ebeff6;
                  }
                  .table-content table tbody  tr td {
                    border: 1px solid #ebeff6;
                  }
                  .table-content table tbody tr td:nth-child(1) {
                    width: 10%;
                  }
                  .table-content table tbody  tr td:nth-child(2) {
                    width: 30%;
                  }
                  .table-content table tbody  tr td:nth-child(3) {
                    width: 10%;
                  }
                  .table-content table tbody  tr td:nth-child(4) {
                    width: 30%;
                  }
                  .table-content table tbody  tr:nth-child(even) {
                    background: #e8f2fb;
                  }
                  .table-content table tbody  tr:nth-child(odd) {
                    background: #ffffff;
                  }
                </style>
            </head>
            <body>
                ${contentDocument}
            </body>
            </html>`
      let converted = htmlDocx.asBlob(content)
      saveAs(converted, '到站率统计.docx')
      let link = this.createDownloadLink(converted, '到站率统计.docx')
      this.$refs.downloadArea.innerHTML = ''
      this.$refs.downloadArea.appendChild(link)
    }
  },
  created () {
    // let now = new Date()
    // this.query.begTime = this.Global.timeFormat(now)
  },
  mounted () {
    this.tabledata()
    tinymce.init({})
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      this.$refs['yuliang'].style.height =
        contentDiv[0].offsetHeight - 30 + 'px'
      let selectHeight = this.$refs.districtrainOperation.offsetHeight
      this.$refs.tableDiv.style.height = this.$refs.yuliang.offsetHeight - selectHeight - 30 + 'px'
    })
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped></style>
<style lang="less" scoped>
.yuliang {
   /deep/ .tableDiv{
      margin-top: 15Px;
      width:98%;
      margin-left: 1%;
      overflow: auto;
      padding-top: 10px;
    }
}
</style>
